import { GetBreakpointWidth } from 'Utils/globals-bp';
import { UpdateSiteHeaderSticky } from 'Modules/headroom.js';

// ===== _PageNav.HW.cshtml - Start =====
// Bind click handler to menu items
// so we can get a fancy scroll animation
function clickHotelMenuItem(e) {
    //var topMenu = $(".page-nav");
    //var topMenuHeight = topMenu.outerHeight();
    var topMenuHeights = getTopMenuHeights();

    if ($(this).hasClass('fullscreen')) {
        fullscreen();
    } else {
        //var href = $(this).attr("href"),
        //    offsetTop = href === "#" ? 0 : $(href).offset().top - topMenuHeight + 1;
        let href = $(this).attr("href");
        let $anchor = $(href);
        let offsetTop = (href === "#" || $anchor.length < 1) ? 0 : $anchor.offset().top;
        if (href.toLowerCase() === "#description") {
            //offsetTop = offsetTop - 16; // arrow height 16px
            offsetTop = offsetTop - topMenuHeights.default + 1;
            offsetTop = offsetTop - 6; // shadow height 6px
        } else {
            offsetTop = offsetTop - topMenuHeights.sticked + 1;
        }
        if (href.toLowerCase() === "#prices") {
            offsetTop = offsetTop + parseInt($("#prices").css('padding-top'));
        }
        if (href.toLowerCase() === "#rooms") {
            //let $anchorRooms = $(href);
            if (isHiddenInsideDescriptionReadMore($anchor)) {
                let $moretext = $anchor.closest(".meretekst");
                let $more = $moretext.next(".mere");
                if ($more.length > 0) {
                    // expand 'read more'
                    $more.trigger("click");
                    // get current position and scroll
                    if ($anchor.is(':visible')) {
                        // wait for other animations
                        setTimeout(function () {
                            // refresh values
                            //topMenuHeight = topMenu.outerHeight();
                            //offsetTop = $anchorRooms.offset().top - topMenuHeight + 1;
                            //offsetTop = offsetTop - 16; // arrow height 16px
                            offsetTop = $anchor.offset().top;
                            offsetTop = offsetTop - topMenuHeights.sticked + 1;
                            offsetTop = offsetTop - 6; // shadow height 6px

                            $('html, body').stop().animate({
                                scrollTop: offsetTop
                            }, 300);
                        }, 500);
                    }
                }
                return;
            }
            //offsetTop = offsetTop - 16; // arrow height 16px
            offsetTop = offsetTop - 6; // shadow height 6px
        }
        $('html, body').stop().animate({
            scrollTop: offsetTop
        }, 300);
    }
    e.preventDefault();
}

function fixHotelNavHeight() {
    //var contentHotelNav = $('.page-nav').find('.c');
    //$('.page-nav').parent('.sticky-wrapper').css('height', contentHotelNav.outerHeight());
    //var $pageNav = $('.page-nav');
    //var m = 0;
    //m = $pageNav.css('margin-bottom');
    //if (m) {
    //    $pageNav.parent('.sticky-wrapper').css('margin-bottom', m);
    //}
}

function fixPageNavTopSpacing() {
    if (!$('.page-nav').is(':visible'))
        return;

    var maxWidth = GetBreakpointWidth();
    var topSpacing = 0;
    if (maxWidth < 480) {
        topSpacing = 86;
    } else if (maxWidth < 768) {
        topSpacing = 86;
    } else {
        topSpacing = 0;
    }
    /*
    $('.page-nav').sticky({ topSpacing: topSpacing, zIndex: 99900, widthFromWrapper: false, getWidthFrom: 'body', responsiveWidth: true, center: true, fixWrapperHeight: false, wrapperClassName: 'page-nav--sticky-wrapper' });
    */
}

function isHiddenInsideDescriptionReadMore($anchor) {
    if (!$anchor || $anchor.length < 1 || $anchor.is(':visible'))
        return false;

    if (!$anchor.is(':hidden'))
        return false;

    let $description = $anchor.closest("#description");
    if ($description.length < 1)
        return false;

    let $moretext = $anchor.closest(".meretekst");
    if ($moretext.length < 1)
        return false;

    return true;
}

function getTopMenuHeights() {
    var topMenu = $(".page-nav");


    var hDefault = parseFloat(topMenu.attr("data-height-default"));
    var hSticked = parseFloat(topMenu.attr("data-height-sticked"));
    if (isNaN(hDefault) || hDefault <= 0 || isNaN(hSticked) || hSticked <= 0) {
        let h = topMenu.outerHeight();
        return {
            default: h,
            sticked: h
        };
    } else {
        return {
            default: hDefault,
            sticked: hSticked
        };
    }
}

AppLoader.loaded(function () {
    if ($('.page-nav').is(':visible')) {

        var updateSiteHeaderSticky = function ($pageNav, isStickied, event) {
            var $header = $('.site-header--fixed');
            if (!$header.length)
                return;

            var wrapperId = "site-header-wrapper";
            var $headerWrapper = $('<div></div>').attr('id', wrapperId);

            var unwrapSiteHeader = function () {
                if ($header.parent("#" + wrapperId).length > 0)
                    $header.unwrap();
            };

            var close_searchautocomplete = function (searchautocomplete) {
                let $searchautocomplete = $(searchautocomplete);
                if ($searchautocomplete && $searchautocomplete.length > 0 && $searchautocomplete.is(':ui-autocomplete')) {
                    $searchautocomplete.autocomplete('close');
                }
            };

            var hideSiteHeader = function () {
                close_searchautocomplete('.searchautocomplete-mobile');
                close_searchautocomplete('.searchautocomplete');

                var maxWidth = GetBreakpointWidth();
                if (maxWidth >= 768) {
                    var h = $header.outerHeight();
                    $header.wrapAll(function () {
                        if ($(this).parent("#" + wrapperId).length == 0) {
                            return $headerWrapper;
                        }
                    });
                    $headerWrapper = $header.parent();
                    $headerWrapper.css('height', h);

                    if (maxWidth == 768) {
                        $headerWrapper.css('position', 'fixed');
                    }
                } else {
                    unwrapSiteHeader();

                    if ($header.css('display') == 'none' || !$header.is(':visible')) {
                        $header.slideDown(200);
                        //$header.css('display', '');
                    }
                    return;
                }

                //siteHeadRoom
                var hasHeadRoom = typeof (global.siteHeadRoom) != "undefined" && global.siteHeadRoom && global.siteHeadRoom.initialised;
                if (!hasHeadRoom) {
                    $header/*.stop()*/.slideUp(200);
                }
            };

            if (isStickied) {
                var $navMobile = $('.site-header').find('.site-nav__mobile');
                if ($navMobile.length && $navMobile.is(':visible')) {
                    $('.site-header').find('.site-nav__mobile').slideUp(200, function () {
                        hideSiteHeader();
                    });
                } else {
                    hideSiteHeader();
                }
                //$header.css('display', 'none');

            } else {
                if ($header.css('display') == 'none' || !$header.is(':visible')) {
                    $header/*.stop()*/.slideDown(200);
                    unwrapSiteHeader();
                }
                //$header.css('display', '');
            }
        };

        /*
        $('.page-nav').sticky({ topSpacing: 0, zIndex: 99900, widthFromWrapper: false, getWidthFrom: 'body', responsiveWidth: true, center: true, fixWrapperHeight: false, wrapperClassName: 'page-nav--sticky-wrapper' })
            .on('sticky-start', function (event, objSticky) {
                //console.log("Started");
                updateSiteHeaderSticky($(this), true, event);
            })
            .on('sticky-end', function (event, objSticky) {
                updateSiteHeaderSticky($(this), false, event);
                //console.log("Ended");
            });
        */


        // Cache selectors
        var lastId,
            firstId = '',
            topMenu = $(".page-nav"),
            //topMenuHeight = topMenu.outerHeight(),
            topMenuHeights = getTopMenuHeights(),
            // All list items
            menuItems = topMenu.find("a"),
            // Anchors corresponding to menu items
            scrollItems = [];

        // Get distinct scrollItems
        var scrollItemsObj = {};
        menuItems.each(function (i, elm) {
            var href = $(elm).attr("href");
            if (href && href !== "#" && href.toLowerCase() !== "#prices") {
                var item = $(href);
                if (item.length && !scrollItemsObj[item.attr("id")]) {
                    scrollItemsObj[item.attr("id")] = item;
                }
            }
        });
        for (var k in scrollItemsObj) {
            var item = scrollItemsObj[k];
            scrollItems.push(item);
            if (firstId == '')
                firstId = k;
        }


        // Bind click handler to menu items
        // so we can get a fancy scroll animation
        menuItems.click(clickHotelMenuItem);


        // Bind to scroll
        $(window).scroll(function (event) {
            // Get container scroll position
            //var fromTop = $(this).scrollTop() + topMenuHeight;
            var fromTop = $(this).scrollTop();

            // Get id of current scroll item
            var cur = [];
            $(scrollItems).each(function (i, item) {
                let id = item.attr("id");

                var offsetTop = item.offset().top;
                if (id.toLowerCase() === "description") {
                    offsetTop = offsetTop - topMenuHeights.default;
                } else {
                    offsetTop = offsetTop - topMenuHeights.sticked;
                }
                offsetTop = offsetTop - 6; // shadow height 6px

                if (id.toLowerCase() === "rooms") {
                    if (isHiddenInsideDescriptionReadMore(item)) {
                        let $moretext = item.closest(".meretekst");
                        let $more = $moretext.next(".mere");
                        if ($more.length > 0) {
                            // take position of 'read more'
                            offsetTop = $more.offset().top;
                        } else {
                            // alternative --> end of 'section#description'
                            let $description = item.closest("#description");
                            offsetTop = $description.offset().top + $description.outerHeight();
                        }
                        //offsetTop = offsetTop - 16; // arrow height 16px
                        offsetTop = offsetTop - topMenuHeights.sticked + 1;
                        offsetTop = offsetTop - 6; // shadow height 6px
                    }
                }

                if (offsetTop < fromTop)
                    cur.push(item);
            });

            // Get the id of the current element
            cur = cur[cur.length - 1];
            var id = cur && cur.length ? cur[0].id : firstId;

            if (lastId !== id) {
                lastId = id;
                // Set/remove active class
                menuItems.removeClass("active");
                menuItems.filter('[href="#' + id + '"]').addClass("active");
            }

            if ($(this).scrollTop() <= 0) {
                updateSiteHeaderSticky($('.page-nav'), false, event);
            }
        });

        fixHotelNavHeight();
        $(window).resize(fixHotelNavHeight);

        fixPageNavTopSpacing();
        $(window).resize(function (event) {
            fixPageNavTopSpacing();
            UpdateSiteHeaderSticky();

            let isStickied = $('.page-nav').length > 0 && $('.page-nav').parent('.sticky-wrapper.is-sticky').length > 0;
            updateSiteHeaderSticky($('.page-nav'), isStickied, event);
        });
    }

    $('.hotel-actionbox-conteiner .menuItem').click(clickHotelMenuItem);
});
// ===== _PageNav.HW.cshtml - End =====